type Listener = () => void;

function createVoiceAvatarDismissalStore() {
  const dismissedUsers = new Set<string>();
  const listeners = new Set<Listener>();
  return {
    isDismissed: (userId: string | null) =>
      Boolean(userId && dismissedUsers.has(userId)),
    dismiss(userId: string | null) {
      if (!userId || dismissedUsers.has(userId)) return;
      dismissedUsers.add(userId);
      for (const listener of listeners) listener();
    },
    subscribe(listener: Listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}

const documentStores = new WeakMap<
  Document,
  ReturnType<typeof createVoiceAvatarDismissalStore>
>();

/** Navigation can remount providers; only a new document resets dismissal. */
export function getVoiceAvatarDismissalStore(document: Document) {
  const existing = documentStores.get(document);
  if (existing) return existing;
  const store = createVoiceAvatarDismissalStore();
  documentStores.set(document, store);
  return store;
}
